import { useTranslation } from 'react-i18next';
import { renderHTMLString } from '../../../../../../helpers';
import EmailOptInModule from '../../../../../styled/siteBuilderModules/EmailOptInModule';
import PaymentJourneyMessage, {
  PaymentJourneyMessageProps,
} from '../../../../shared/components/PaymentJourneyMessage';

import { ModuleWrapper } from './styles';
import { useSelector } from 'react-redux';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

export interface BookingClosedMessageProps
  extends Partial<PaymentJourneyMessageProps> {
  errorMessage?: string;
}

export default function BookingClosedMessage(props: BookingClosedMessageProps) {
  const { errorMessage, ...restProps } = props;
  const { t } = useTranslation();
  const { location } = useSelector(selectPageConfig);

  return (
    <PaymentJourneyMessage
      title={t('site.pricing.booking-closed')}
      description={errorMessage && renderHTMLString(errorMessage, location)}
      button={
        <ModuleWrapper>
          <EmailOptInModule
            section={{
              contentType: 'booking_closed',
              type: 'event_lead_generation_section',
            }}
          />
        </ModuleWrapper>
      }
      {...restProps}
    />
  );
}
